/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {checkMicroAuthEligibility} from '../api'

export const useMutationCheckMicroAuthEligibility = createReactQueryMutationHook('checkMicroAuthEligibility', checkMicroAuthEligibility)
